module.exports = __webpack_public_path__ + "img/download.a21db440.svg";